'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoTrashB = function IoTrashB(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.3 10.4c0.3 0.9 0.4 0.9-0.5 0.9h-23.6c-0.9 0-0.8 0-0.5-0.9 0.1-0.7 0.3-1 0.3-1 0.2-0.7 0.7-0.7 1.5-0.9l4.1-0.5c0.5-0.1 0.5-0.1 0.8-0.6 0.7-1.5 0.8-2.4 1.5-2.4h8.1c0.8 0 0.9 0.9 1.6 2.4 0.3 0.5 0.3 0.5 0.8 0.6l4.1 0.4c0.8 0.2 1.3 0.2 1.5 0.9 0 0 0.2 0.4 0.3 1.1z m-2.7 3.4c1.3 0 1.4 0.1 1.3 1.1l-1.4 18.9c-0.2 1-0.2 1.2-1.4 1.2h-16.2c-1.2 0-1.2-0.2-1.4-1.2l-1.4-18.9c-0.1-0.9 0-1.1 1.3-1.1h19.2z' })
        )
    );
};

exports.default = IoTrashB;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/trash-b.js
// module id = 2541
// module chunks = 0